export default __webpack_public_path__ + "7ddc85980b80ce43309a5a6ec0690a1e.png";